import LoggedOutLayout from './LoggedOutLayout';

export default LoggedOutLayout;
